<template>
  <div class="warp">
    <div class="cententbox" ref="pageh">
      <!--搜索-->
      <div class="search-area" ref="pagehcf">
        <div></div>
        <div class="search-area-left">
          <div class="search-area-item">
            <span class="titlt">{{
              $t("message.userPatrol.searchLable.PlanName")
            }}</span>
            <el-input
              v-model="planName"
              :placeholder="
                $t('message.userPatrol.placeholder.PleaseEnterThePlanMame')
              "
              maxlength="50"
              class="inputwid160"
            ></el-input>
          </div>
          <div class="search-area-item">
            <span class="titlt">{{
              $t("message.userPatrol.searchLable.PatrolUsers")
            }}</span>
            <el-input
              v-model="username"
              :placeholder="
                $t('message.userPatrol.placeholder.PleaseEnterThePatrolUser')
              "
              maxlength="50"
              class="inputwid160"
            ></el-input>
          </div>
          <div class="search-area-item">
            <span class="titlt">{{
              $t("message.userPatrol.searchLable.ExecutionResult")
            }}</span>
            <el-select
              v-model="state"
              clearable
              :placeholder="
                $t(
                  'message.userPatrol.placeholder.PleaseSelectTheExecutionResult',
                )
              "
              class="inputwid160"
            >
              <el-option
                v-for="item in planStatusList"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="search-area-item">
            <span class="titlt">{{
              $t("message.userPatrol.searchLable.PatrolTime")
            }}</span>
            <el-date-picker
              v-model="patrolDate"
              type="datetimerange"
              range-separator="-"
              :start-placeholder="$t('message.userPatrol.StartingRange')"
              :end-placeholder="$t('message.userPatrol.EndRange')"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
              :picker-options="pickerOptions"
              popper-class="data-picker-popper"
              style="width:420px"
              clearable
              align="right"
            >
            </el-date-picker>
          </div>
          <div class="btn" @click="searchPlan">{{ $t("message.search") }}</div>
        </div>
      </div>

      <div class="publicTable">
        <el-table
          :data="tableData"
          height="100%"
          border
          empty-text
          style="width: 100%"
          :cellStyle="{
            padding: '4px',
            fontSize: '14px',
            textAlign: 'center',
            color: '#000',
          }"
        >
          <el-table-column
            prop="planName"
            :label="$t('message.userPatrol.tableHeader.PlanName')"
            width="300"
          >
          </el-table-column>

          <el-table-column
            prop="pointNames"
            :label="$t('message.userPatrol.tableHeader.patrolPoint')"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="usernames"
            :label="$t('message.userPatrol.tableHeader.PatrolUsers')"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="beginTime"
            :label="$t('message.userPatrol.tableHeader.StartTime')"
            width="250"
          >
          </el-table-column>
          <el-table-column
            prop="endTime"
            :label="$t('message.userPatrol.tableHeader.EndTime')"
            width="250"
          >
          </el-table-column>
          <el-table-column
            :label="$t('message.userPatrol.tableHeader.ExecutionResult')"
            width="150"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.state != null">{{
                scope.row.state == 0
                  ? $t("message.userPatrol.status.NotStarted")
                  : scope.row.state == 1
                  ? $t("message.userPatrol.status.InProgress")
                  : scope.row.state == 2
                  ? $t("message.userPatrol.status.Completed")
                  : $t("message.userPatrol.status.MissingPatrol")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.operate')" width="250">
            <template slot-scope="scope">
              <span
                class="x-text-c textcolor"
                @click="openDetails(scope.row.id)"
                >{{ $t("message.userPatrol.ViewDetails") }}
              </span>
              <span class="backslash">/</span>
              <span
                class="x-text-c textcolor"
                @click="patrolTrajectory(scope.row, 3)"
                >{{ $t("message.userPatrol.PatrolTrajectory") }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页器 -->
      <div class="flexcl">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[20, 40, 60, 80]"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper,slot, sizes"
          :total="total"
        >
          <span class="confirbtn">{{ $t("message.confirm") }}</span>
        </el-pagination>
      </div>
    </div>

    <dialogbox
      ref="dialogbox"
      :dialogTitle="dialogTitle"
      :dialogData="userData"
      :butName="butName"
      :cancelBut="cancelBut"
      :bgShow="bgShow"
      :timeShow="timeShow"
      :width="dialogWidth"
      :patrolTrajectory="true"
    >
    </dialogbox>
  </div>
</template>
<script>
import axios from "axios";
import beasconfig from "@/api/beasconfig.js";
import dialogbox from "@/components/dispatchLntercom/dialogbox.vue";
const xinPatrolApi = beasconfig.xinPatrolApi;
export default {
  name: "performTsks",
  components: {
    dialogbox,
  },
  data() {
    return {
      planName: "",
      username: "",
      state: "",
      patrolDate: [],
      pickerOptions: {
        disabledDate(time) {
          //日期选择，禁用今天之后的日期
          return time.getTime() > Date.now();
        },
      },
      planStatusList: [
        {
          text: this.$t(
            "message.userPatrol.placeholder.PleaseSelectTheExecutionResult",
          ),
          value: -1,
        },
        {
          text: this.$t("message.userPatrol.status.NotStarted"),
          value: 0,
        },
        {
          text: this.$t("message.userPatrol.status.InProgress"),
          value: 1,
        },
        {
          text: this.$t("message.userPatrol.status.Completed"),
          value: 2,
        },
        {
          text: this.$t("message.userPatrol.status.MissingPatrol"),
          value: 3,
        },
      ],
      tableData: [
        // {
        //   id: 1, //计划 id
        //   state: "", //状态 0：未开始 1：进行中 2：完成 3：漏巡
        //   planName: "", //计划名称
        //   pointNames: "巡更点1,巡更点2,巡更点3", //巡更点
        //   usernames: "用户1,用户2,用户3",//巡更用户名称
        //   beginTime: "2025-04-06 00:00:00",//开始时间
        //   endTime: "2025-04-06 00:00:00",//结束时间
        // },
      ],
      pageNum: 1,
      pageSize: 20,
      total: 0,

      dialogWidth: "960px",
      bgShow: false,
      timeShow: false,
      dialogTitle: "",
      butName: "",
      cancelBut: "",
      userData: {},
    };
  },
  watch: {
    state(val) {
      if (val == -1) {
        this.state = "";
      }
    },
  },
  created() {
    this.searchPlan();
    // this.getTipData();
  },
  mounted() {},
  methods: {
    patrolTrajectory(row, type) {
      this.bgShow = false;
      this.timeShow = true;
      this.dialogTitle = this.$t("message.selectionPeriod");
      this.butName = this.$t("message.Sure");
      this.cancelBut = this.$t("message.Closure");
      this.userData = row;
      setTimeout(() => {
        this.$refs.dialogbox.openPg(type, row);
      }, 200);
    },

    //跳转新增、编辑、详情页
    openDetails(id) {
      this.$router.push({
        path: "/history/performTsksDetails",
        query: {
          id: id, //计划id
        },
      });
    },

    //搜索
    searchPlan() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        planName: this.planName,
        username: this.username,
        state: this.state,
        startDate: this.patrolDate ? this.patrolDate[0] : "",
        endDate: this.patrolDate ? this.patrolDate[1] : "",
      };
      for (let i in params) {
        if (params[i] === "") {
          delete params[i];
        }
      }
      axios
        .get(xinPatrolApi + "/api/task/list", {
          params: { ...params },
          headers: {
            key: this.$store.state.userInfo.User_ID,
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.tableData = [];
            let data = res.data.data;
            this.total = data.total;
            data.list.forEach((item) => {
              // //巡更点列表
              let pointNameList = [];
              item.records.forEach((item) => {
                pointNameList.push(item.pointName);
              });

              let obj = {
                id: item.id,
                state: item.state,
                planName: item.planName,
                beginTime: this.$moment(item.beginTime).format(
                  "YYYY-MM-DD HH:mm:ss",
                ),
                endTime: this.$moment(item.endTime).format(
                  "YYYY-MM-DD HH:mm:ss",
                ),
                pointNames: pointNameList.join(","),
                usernames: item.username,
                userid: item.userid,
              };
              this.tableData.push(obj);
            });
          }
        });
    },

    //返回
    backbtn() {
      this.planName = "";
      this.username = "";
      this.state = "";
      this.patrolDate = [];
      this.searchPlan("init");
    },

    //表格样式
    ceelStyle() {
      return "padding:4px;font-size:13px;color: #000000";
    },

    //分页器
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.searchPlan();
    },
    //分页器
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum;
      this.searchPlan();
    },
  },
};
</script>
<style lang="less" scoped>
.warp {
  // min-width: 900px;
  height: 100%;
  .cententbox {
    padding: 10px;
    height: calc(100% - 20px);
    background-color: #ffffff;
    .persontextbox {
      height: 42px;
      border-bottom: 1px solid #ddd;
      .persontext {
        display: inline-block;
        height: 41px;
        line-height: 41px;
        padding: 0 20px;
        font-size: 15px;
        color: #888;
        border: 1px solid #ddd;
        border-bottom-color: #fff;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
        background-color: #fff;
      }
    }

    .disflex {
      display: flex;
      flex-direction: row;
    }

    .disflexc {
      display: flex;
      flex-direction: column;
      // justify-content: space-between;
    }

    .flexspan {
      justify-content: space-between;
    }

    .flexdivcl {
      justify-content: space-around;
    }

    .flexal {
      align-items: center;
      // margin:10px;
    }

    .divwidcl {
      width: 80%;
    }

    .heaedercl {
      justify-content: space-between;
      background: #f0f0f0;
      margin: 10px 0;
      padding: 10px;
    }

    .inputwid200 {
      width: 180px;
    }

    .inputwid140 {
      width: 150px;
    }

    .marright {
      margin-right: 5px;
    }

    .inputwid160 {
      width: 208px;
    }

    .inputwid120 {
      width: 180px;
    }

    .spancl {
      display: block;
    }

    .excelcl {
      position: absolute;
      bottom: 20px;
    }

    .spanrightcl {
      margin-right: 10px;
    }

    .changeagentcl {
      display: inline-block;
      /* background-color: #002FA7; */
      padding: 10px 20px;
      /* color: #ffffff; */
      border-radius: 5px;
      cursor: pointer;
      margin-left: 10px;
    }

    // /deep/.el-input__inner:focus {
    //   border-color: #002fa7;
    // }

    .secondcl {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-left: 80px;
      margin-top: 10px;
    }

    .search-area {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
      margin: 0 0 10px;
      background: #f0f0f0;
      .search-area-left {
        // width: 100%;
        display: flex;
        &:after {
          content: "";
          height: 0;
          clear: both;
          visibility: hidden;
          display: block;
        }
        .btn {
          min-width: 70px;
          padding: 0px 5px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          background-color: #4d4d4d;
          background-size: 100% 100%;
          border-radius: 5px;
          color: #ffffff !important;
        }
        .search-area-item {
          margin-right: 30px;
          display: flex;
          align-items: center;
          // float: left;
          .titlt {
            margin-right: 10px;
            min-width: 60px;
          }
        }
      }
      .baack-empty {
        padding: 10px 20px;
        font-size: 14px;
        border-radius: 4px;
        color: #fff;
        background-color: #5a5657;
        border-color: #fff;
        display: inline-block;
        cursor: pointer;
        margin-right: 20px;
        margin-top: 10px;
        min-width: 28px;
      }
    }
  }
}
.publicTable {
  height: calc(100% - 70px - 42px);
  /deep/.el-table {
    background-color: #ffffff !important;
    & th > .cell {
      text-align: center;
      color: #000000;
      font-weight: bold;
    }
    .textcolor {
      cursor: pointer;
    }
  }
}
.flexcl {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
  /deep/.el-pagination {
    .el-pagination__jump {
      margin-left: 0;
    }
    .confirbtn {
      background-color: #5a5657;
      padding: 0 6px;
      color: #ffffff;
      margin-left: 4px;
      cursor: pointer;
      border-radius: 2px;
      // line-height: 14px;
    }
  }
}
.x-text-c {
  color: var(--main-color);
}
.red {
  color: red;
}
</style>
